import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { NotFoundError } from 'src/shared/error';

import type { PaginatedContextData, PaginatedData } from 'src/app/shared/contexts/asyncData';

import { TopicTrendingPetitions } from './api.graphql';
import type { TopicTrendingPetitionsQuery, TopicTrendingPetitionsQueryVariables } from './api.graphql';
import type { TopicTrendingPetitionsItem } from './types';

type TopicTrendingPetitionsApiData = PaginatedData<
	TopicTrendingPetitionsItem,
	{
		totalCount: number;
		totalCountLocalized: string;
	}
>;

export type TopicTrendingPetitionsData = PaginatedContextData<TopicTrendingPetitionsApiData>;

async function getData(
	{ gql: { fetch } }: UtilityContext,
	slug: string,
	cursor?: string,
): Promise<TopicTrendingPetitionsApiData> {
	const { data } = await fetch<TopicTrendingPetitionsQuery, TopicTrendingPetitionsQueryVariables>({
		query: TopicTrendingPetitions,
		variables: { cursor: cursor ?? null, slug },
		rejectOnError: true,
	});

	if (!data.topicPage) throw new NotFoundError();

	return {
		items: data.topicPage.trendingPetitionsConnection.edges,
		cursor: data.topicPage.trendingPetitionsConnection.pageInfo.endCursor,
		hasNextPage: data.topicPage.trendingPetitionsConnection.pageInfo.hasNextPage,
		totalCount: data.topicPage.trendingPetitionsConnection.totalCount,
		totalCountLocalized: data.topicPage.trendingPetitionsConnection.totalCountLocalized,
	};
}

export async function getFirstPageData(utilityContext: UtilityContext, slug: string) {
	return getData(utilityContext, slug);
}

export async function getNextPageData(utilityContext: UtilityContext, cursor: string, slug: string) {
	return getData(utilityContext, slug, cursor);
}
